import chokidar from 'chokidar'

import fs from 'node:fs'
import path from 'node:path'

import { isUrl } from '@/domains/document/helpers/file-type'
import { output } from '@/helpers/std-out'

/**
 * Watch a foobar for changes and call a callback when it does.
 */
export const watchFile = async (
  file: string,
  callback: () => void,
  options?: { immediate?: boolean },
) => {
  // Poll URLs
  if (isUrl(file)) {
    setInterval(callback, 5000)
    return
  }

  const absoluteFilePath = path.join(process.cwd(), file)

  // Check if file exists
  if (!fs.existsSync(absoluteFilePath)) {
    throw new Error(`File ${absoluteFilePath} does not exist`)
  }

  // Watch the file for changes
  output.info().title(`Watch ${file}`).print()

  const watcher = chokidar.watch(file, { persistent: true })

  watcher.on('change', () => {
    callback()
  })

  // Call the callback immediately
  if (options?.immediate) {
    callback()
  }

  return {
    unsubscribe: () => watcher.close(),
  }
}
